var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.999901 0.999899C1.50758 0.4792 2.49222 0.4792 2.9999 0.999899L7.9999 5.9999L11.9999 0.999899C12.5076 0.4792 13.4922 0.4792 13.9999 0.999899C14.5076 1.5206 14.5076 2.4792 13.9999 2.9999L7.9999 8.9999C7.49222 9.5206 7.50758 9.5206 6.9999 8.9999L0.999901 2.9999C0.49222 2.4792 0.49222 1.5206 0.999901 0.999899Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.6521ee05880d3d803d526cb2f1210f16.svg";
export { ForwardRef as ReactComponent };